import axiosInstance from './axiosInstance';
import { TimeSheet, CreateTimeSheetDto, UpdateTimeSheetDto, TimeSheetFilter, BulkTimeSheetDto, EmployeeTimeSheetSummary } from '../types/timesheets.types';

const API_URL = '/TimeSheets';

const timeSheetsService = {
  getAll: async (filter?: TimeSheetFilter): Promise<TimeSheet[]> => {
    const params = new URLSearchParams();
    if (filter?.branchId) params.append('branchId', filter.branchId.toString());
    if (filter?.startDate) params.append('startDate', filter.startDate);
    if (filter?.endDate) params.append('endDate', filter.endDate);
    if (filter?.employeeId) params.append('employeeId', filter.employeeId.toString());
    
    const response = await axiosInstance.get(`${API_URL}?${params.toString()}`);
    return response.data;
  },

  getSummaries: async (filter?: TimeSheetFilter): Promise<EmployeeTimeSheetSummary[]> => {
    const params = new URLSearchParams();
    if (filter?.branchId) params.append('branchId', filter.branchId.toString());
    if (filter?.startDate) params.append('startDate', filter.startDate);
    if (filter?.endDate) params.append('endDate', filter.endDate);
    if (filter?.employeeId) params.append('employeeId', filter.employeeId.toString());
    
    const response = await axiosInstance.get(`${API_URL}/summaries?${params.toString()}`);
    return response.data;
  },

  getById: async (id: number): Promise<TimeSheet> => {
    const response = await axiosInstance.get(`${API_URL}/${id}`);
    return response.data;
  },

  create: async (timeSheet: CreateTimeSheetDto): Promise<TimeSheet> => {
    const response = await axiosInstance.post(API_URL, timeSheet);
    return response.data;
  },

  update: async (id: number, timeSheet: UpdateTimeSheetDto): Promise<TimeSheet> => {
    const response = await axiosInstance.put(`${API_URL}/${id}`, timeSheet);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await axiosInstance.delete(`${API_URL}/${id}`);
  },

  bulkCreateOrUpdate: async (data: BulkTimeSheetDto): Promise<TimeSheet[]> => {
    const response = await axiosInstance.post(`${API_URL}/bulk`, data);
    return response.data;
  },

  getReport: async (params: any): Promise<any> => {
    const response = await axiosInstance.get(`${API_URL}/report`, { params });
    return response.data;
  }
};

export default timeSheetsService;